import Configuration from '@utils/configuration'

const URLS = {
  cmsAbResources: 'http://go.cms.gov/CCIIOAB',
  learnMoreAboutPlatform: 'https://www.healthsherpa.com/agents/features',
  registrationTracker: 'https://data.healthcare.gov/ab-registration-tracker',
  returnToCms: Configuration.cmsPortalLink,
  privacyNotice: 'https://www.healthsherpa.com/privacy_notice',
  termsOfService: 'https://www.healthsherpa.com/terms_of_service',
  nipr: 'https://www.nipr.com',
  faq: 'http://faq.healthsherpa.com/en/articles/6542734-ffm-training-on-healthsherpa-post-training-faq',
}

export default URLS
